.pathCard {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  padding: 1.75rem;
  height: 100%;
  background: var(--color-surface);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-md);
}

.pathIcon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.8rem;
  height: 2.8rem;
  border-radius: var(--radius-sm);
  background: var(--color-primary-soft);
  color: var(--color-primary-strong);
}

.pathTitle {
  font-family: var(--font-sans);
  font-size: var(--fs-h3);
  font-weight: 600;
}

.pathBody {
  color: var(--color-text-muted);
  line-height: 1.6;
}

.contact {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: clamp(2rem, 5vw, 3.5rem);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-lg);
  background: var(--color-surface);
}

.contactTitle {
  font-size: var(--fs-h2);
}

.contactBody {
  color: var(--color-text-muted);
  max-width: 42rem;
}

.contactGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.25rem;
  margin-top: 0.5rem;
}

.contactPerson {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  padding: 1.25rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border);
  background: var(--color-bg);
}

.contactName {
  font-weight: 600;
  font-size: 1.1rem;
}

.contactRole {
  font-family: var(--font-mono);
  font-size: 0.78rem;
  letter-spacing: 0.04em;
  color: var(--color-text-faint);
}

.contactEmail {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.5rem;
  padding: 0.7rem 1.15rem;
  width: fit-content;
  border-radius: var(--radius-pill);
  background: var(--color-primary);
  color: #fff;
  font-weight: 600;
  font-size: 0.92rem;
  transition: background var(--dur-base);
}

.contactEmail:hover {
  background: var(--color-primary-strong);
}

.contactNote {
  font-size: 0.88rem;
  color: var(--color-text-faint);
}

@media (max-width: 700px) {
  .contactGrid {
    grid-template-columns: 1fr;
  }
}
